import * as React from 'react';
import type { IconProps } from '../icon-prop-types';
const TESTID = 'play-store-inverted-svg';
export const PlayStoreInvertedIcon = ({ width = 140, height = 42 }: IconProps) => {
    return (
        <svg
            data-testid={TESTID}
            width={width}
            height={height}
            viewBox="0 0 148 44"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>App Badges / Android - Black + Color</title>
            <path
                id="Path"
                fill="white"
                d="M142.5,44H5.5c-3,0-5.5-2.5-5.5-5.5v-33C0,2.5,2.5,0,5.5,0h137c3,0,5.5,2.5,5.5,5.5v33
	C148,41.5,145.5,44,142.5,44"
            />
            <path
                id="Path_00000078034305979670878760000002774494048541710476_"
                fill="black"
                d="M52.7,11.3c0,0.9-0.3,1.7-0.8,2.2
	c-0.6,0.7-1.4,1-2.4,1c-1,0-1.8-0.3-2.5-1c-0.7-0.7-1-1.5-1-2.5c0-1,0.3-1.8,1-2.5c0.7-0.7,1.5-1,2.5-1c0.5,0,0.9,0.1,1.4,0.3
	c0.4,0.2,0.8,0.4,1,0.7l-0.6,0.6c-0.4-0.5-1-0.8-1.8-0.8c-0.7,0-1.3,0.2-1.8,0.7c-0.5,0.5-0.8,1.1-0.8,1.9c0,0.8,0.3,1.4,0.8,1.9
	c0.5,0.5,1.1,0.7,1.8,0.7c0.7,0,1.4-0.2,1.9-0.7c0.3-0.3,0.5-0.8,0.6-1.3h-2.4v-0.8h3.2C52.7,10.9,52.7,11.1,52.7,11.3"
            />
            <path
                id="Shape_00000176027105856215315520000004595775811936415641_"
                fill="black"
                d="M52.7,11.3h-0.1c0,0.9-0.3,1.6-0.8,2.1l0,0
	l0,0c-0.6,0.6-1.4,0.9-2.4,0.9c-0.9,0-1.7-0.3-2.4-1c-0.7-0.6-1-1.4-1-2.4c0-1,0.3-1.7,1-2.4c0.7-0.6,1.4-1,2.4-1
	c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.8,0.4,1,0.7l0.1-0.1l-0.1-0.1l-0.6,0.6l0.1,0.1l0.1-0.1c-0.5-0.5-1.1-0.8-1.9-0.8
	c-0.7,0-1.4,0.3-1.9,0.8c-0.5,0.5-0.8,1.2-0.8,2c0,0.8,0.3,1.5,0.8,2c0.5,0.5,1.2,0.8,1.9,0.8c0.8,0,1.4-0.3,1.9-0.8
	c0.3-0.3,0.5-0.8,0.6-1.4l0-0.1h-2.4v-0.6h3.1v-0.1l-0.1,0c0,0.2,0,0.3,0,0.5h0.2c0-0.2,0-0.3,0-0.5l0-0.1h-3.4v1h2.5v-0.1l-0.1,0
	c0,0.6-0.2,1-0.5,1.3c-0.5,0.5-1.1,0.7-1.8,0.7c-0.7,0-1.2-0.2-1.7-0.7c-0.5-0.5-0.7-1.1-0.7-1.8c0-0.8,0.2-1.4,0.7-1.8
	c0.5-0.5,1.1-0.7,1.7-0.7c0.8,0,1.3,0.2,1.7,0.7l0.1,0.1l0.7-0.7L52,8.6l-0.1-0.1c-0.3-0.3-0.6-0.6-1.1-0.8
	c-0.4-0.2-0.9-0.3-1.4-0.3c-1,0-1.8,0.3-2.5,1c-0.7,0.7-1,1.5-1,2.5c0,1,0.3,1.9,1,2.5c0.7,0.7,1.5,1,2.5,1c1,0,1.9-0.3,2.5-1
	l-0.1-0.1l0.1,0.1c0.6-0.6,0.9-1.3,0.9-2.3H52.7 M57.8,8.5h-3v2.1h2.7v0.8h-2.7v2.1h3v0.8h-3.9V7.7h3.9V8.5"
            />
            <path
                id="Shape_00000156568687379622525750000009495831228169007525_"
                fill="black"
                d="M57.8,8.5V8.4h-3.1v2.3h2.7v0.6l-2.7,0v2.3h3
	v0.6H54V7.8h3.7v0.7H57.8V8.4V8.5h0.1V7.6h-4.1v6.8h4.1v-1h-3v-1.9h2.7v-1h-2.7V8.6h3V8.5H57.8 M61.4,14.3h-0.9V8.5h-1.9V7.7h4.6
	v0.8h-1.9V14.3"
            />
            <path
                id="Shape_00000005243395932253248000000003977447919296759221_"
                fill="black"
                d="M61.4,14.3v-0.1h-0.7V8.4h-1.9V7.8h4.4v0.6
	h-1.9v5.9L61.4,14.3v-0.1V14.3l0.1,0V8.6h1.9v-1h-4.8v1h1.9v5.8h1.1v-0.1L61.4,14.3 M66.6,14.3V7.7h0.9v6.6L66.6,14.3"
            />
            <path
                id="Shape_00000019643346429155342930000006686398393122091964_"
                fill="black"
                d="M66.6,14.3h0.1V7.8h0.6v6.4h-0.7V14.3l0.1,0
	L66.6,14.3v0.1h1V7.6h-1.1v6.8h0.1V14.3 M71.3,14.3h-0.9V8.5h-1.9V7.7h4.6v0.8h-1.9V14.3"
            />
            <path
                id="Shape_00000128450107991304586190000014875404382318370183_"
                fill="black"
                d="M71.3,14.3v-0.1h-0.7V8.4h-1.9V7.8H73v0.6
	h-1.9v5.9L71.3,14.3v-0.1V14.3l0.1,0V8.6h1.9v-1h-4.8v1h1.9v5.8h1.1v-0.1L71.3,14.3 M77.5,12.9c0.5,0.5,1.1,0.7,1.8,0.7
	s1.3-0.2,1.8-0.7c0.5-0.5,0.7-1.1,0.7-1.9c0-0.8-0.2-1.4-0.7-1.9c-0.5-0.5-1.1-0.7-1.8-0.7S78,8.6,77.5,9.1
	c-0.5,0.5-0.7,1.1-0.7,1.9S77,12.4,77.5,12.9z M81.8,13.4c-0.7,0.7-1.5,1-2.4,1c-1,0-1.8-0.3-2.4-1c-0.7-0.7-1-1.5-1-2.4
	s0.3-1.8,1-2.4c0.7-0.7,1.5-1,2.4-1c1,0,1.8,0.3,2.4,1c0.7,0.7,1,1.5,1,2.4C82.8,12,82.4,12.8,81.8,13.4z"
            />
            <path
                id="Shape_00000155124671603353750850000006392661675368724903_"
                fill="black"
                d="M77.5,12.9L77.5,12.9c0.4,0.6,1.1,0.9,1.8,0.9
	c0.7,0,1.4-0.3,1.9-0.8c0.5-0.5,0.8-1.2,0.8-2c0-0.8-0.3-1.5-0.8-2c-0.5-0.5-1.2-0.8-1.9-0.8c-0.7,0-1.4,0.3-1.9,0.8
	c-0.5,0.5-0.8,1.2-0.8,2C76.7,11.8,76.9,12.5,77.5,12.9L77.5,12.9L77.5,12.9c-0.4-0.6-0.6-1.1-0.6-1.9c0-0.7,0.2-1.3,0.7-1.8
	c0.5-0.5,1-0.7,1.7-0.7c0.7,0,1.3,0.2,1.7,0.7c0.5,0.5,0.7,1.1,0.7,1.8c0,0.7-0.2,1.3-0.7,1.8c-0.5,0.5-1,0.7-1.7,0.7
	C78.7,13.5,78.1,13.3,77.5,12.9L77.5,12.9z M81.8,13.4L81.8,13.4c-0.7,0.6-1.5,0.9-2.4,0.9c-0.9,0-1.7-0.3-2.4-1l0,0l0,0
	c-0.6-0.6-0.9-1.4-1-2.4c0-0.9,0.3-1.7,1-2.4c0.6-0.6,1.4-1,2.4-1c0.9,0,1.7,0.3,2.4,1c0.6,0.7,1,1.4,1,2.4
	C82.7,11.9,82.3,12.7,81.8,13.4L81.8,13.4L81.8,13.4c0.8-0.6,1.1-1.5,1.1-2.4c0-1-0.3-1.8-1-2.5c-0.7-0.7-1.5-1-2.5-1
	c-1,0-1.9,0.3-2.5,1v0c-0.7,0.7-1,1.5-1,2.5c0,1,0.3,1.8,1,2.5l0,0l0,0c0.7,0.7,1.5,1,2.5,1C80.3,14.6,81.2,14.2,81.8,13.4
	L81.8,13.4L81.8,13.4z M84,14.3V7.7h1l3.2,5.1h0l0-1.3V7.7h0.9v6.6h-0.9l-3.4-5.4h0l0,1.3v4.1L84,14.3"
            />
            <path
                id="Shape_00000073698174174006278240000005466436411610225558_"
                d="M84,14.3h0.1V7.8H85l3.2,5.1h0.2l0-1.4V7.8H89v6.4h-0.7
	l-3.4-5.4h-0.2l0,1.4v4H84L84,14.3l0.1,0L84,14.3l0,0.1h1v-4.2l0-1.3l-0.1,0V9h0V8.9L84.7,9l3.4,5.4h1.1V7.6h-1.1v4l0,1.3l0.1,0
	v-0.1h0v0.1l0.1-0.1l-3.3-5.2h-1.2v6.8H84L84,14.3 M118.8,33h2.1V19.2h-2.1L118.8,33z M137.5,24.2l-2.4,6H135l-2.5-6h-2.2l3.7,8.3
	l-2.1,4.6h2.2l5.7-13H137.5z M125.7,31.4c-0.7,0-1.6-0.3-1.6-1.2c0-1.1,1.2-1.5,2.2-1.5c0.9,0,1.3,0.2,1.9,0.5
	C128,30.5,126.9,31.4,125.7,31.4L125.7,31.4z M126,23.9c-1.5,0-3.1,0.7-3.7,2.1l1.8,0.8c0.4-0.8,1.1-1,1.9-1c1.1,0,2.2,0.6,2.2,1.8
	v0.1c-0.4-0.2-1.2-0.5-2.2-0.5c-2,0-4,1.1-4,3.1c0,1.8,1.6,3,3.4,3c1.4,0,2.2-0.6,2.6-1.3h0.1V33h2v-5.3
	C130.2,25.3,128.4,23.9,126,23.9L126,23.9z M113.2,25.9h-2.9v-4.7h2.9c1.6,0,2.4,1.3,2.4,2.4C115.6,24.6,114.7,25.9,113.2,25.9z
	 M113.1,19.2h-5V33h2.1v-5.2h2.9c2.3,0,4.6-1.6,4.6-4.3C117.7,20.9,115.4,19.2,113.1,19.2z M86,31.4c-1.4,0-2.6-1.2-2.6-2.8
	c0-1.6,1.2-2.9,2.6-2.9c1.4,0,2.5,1.2,2.5,2.9C88.6,30.3,87.4,31.4,86,31.4L86,31.4z M88.4,25L88.4,25c-0.5-0.5-1.4-1-2.6-1
	c-2.4,0-4.5,2.1-4.5,4.7c0,2.6,2.2,4.7,4.5,4.7c1.1,0,2-0.5,2.5-1.1h0.1v0.7c0,1.8-1,2.7-2.5,2.7c-1.3,0-2.1-0.9-2.4-1.7l-1.8,0.7
	c0.5,1.2,1.9,2.8,4.2,2.8c2.4,0,4.5-1.4,4.5-4.9v-8.4h-2V25z M91.8,33h2.1V19.2h-2.1V33z M96.9,28.5c-0.1-1.8,1.4-2.7,2.5-2.7
	c0.8,0,1.5,0.4,1.8,1L96.9,28.5z M103.4,26.9c-0.4-1-1.6-3-4-3c-2.4,0-4.5,1.9-4.5,4.7c0,2.6,2,4.7,4.7,4.7c2.2,0,3.4-1.3,3.9-2.1
	l-1.6-1.1c-0.5,0.8-1.3,1.3-2.3,1.3c-1.1,0-1.8-0.5-2.3-1.4l6.3-2.6L103.4,26.9z M53,25.4v2h4.8c-0.1,1.1-0.5,1.9-1.1,2.5
	c-0.7,0.7-1.8,1.5-3.7,1.5c-3,0-5.3-2.4-5.3-5.3c0-2.9,2.3-5.3,5.3-5.3c1.6,0,2.8,0.6,3.6,1.4l1.4-1.4c-1.2-1.1-2.8-2-5-2
	c-4,0-7.4,3.3-7.4,7.3c0,4,3.4,7.3,7.4,7.3c2.2,0,3.8-0.7,5.1-2c1.3-1.3,1.7-3.2,1.7-4.6c0-0.5,0-0.9-0.1-1.2H53z M65.4,31.4
	c-1.4,0-2.7-1.2-2.7-2.8c0-1.7,1.2-2.8,2.7-2.8c1.4,0,2.7,1.2,2.7,2.8C68,30.3,66.8,31.4,65.4,31.4z M65.4,23.9
	c-2.6,0-4.7,2-4.7,4.7c0,2.7,2.1,4.7,4.7,4.7c2.6,0,4.7-2,4.7-4.7C70.1,25.9,68,23.9,65.4,23.9z M75.7,31.4c-1.4,0-2.7-1.2-2.7-2.8
	c0-1.7,1.2-2.8,2.7-2.8c1.4,0,2.7,1.2,2.7,2.8C78.4,30.3,77.1,31.4,75.7,31.4L75.7,31.4z M75.7,23.9c-2.6,0-4.7,2-4.7,4.7
	c0,2.7,2.1,4.7,4.7,4.7c2.6,0,4.7-2,4.7-4.7C80.5,25.9,78.3,23.9,75.7,23.9L75.7,23.9z"
            />
            <path
                d="M11.3,8.4c-0.1,0.3-0.2,0.7-0.2,1.1V34c0,0.4,0.1,0.8,0.2,1.1l13.4-13.4L11.3,8.4z M12.1,35.9
	c0.5,0.2,1.1,0.1,1.8-0.3l15.7-8.9l-4.2-4.2L12.1,35.9z M30.6,26.1l4.9-2.8c1.6-0.9,1.6-2.3,0-3.2l-4.9-2.8l-4.4,4.4L30.6,26.1z
	 M29.6,16.8L13.9,7.8c-0.7-0.4-1.4-0.5-1.8-0.3l13.4,13.4L29.6,16.8z"
            />
        </svg>
    );
};
PlayStoreInvertedIcon.TEST_ID = TESTID;
